module.exports = __webpack_public_path__ + "static/img/bifc-Integrated-management.09bff8e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/bifc-Integrated-management.jpg
// module id = vK9e
// module chunks = 0